module.exports = __webpack_public_path__ + "img/dating_style.b7c20c08.svg";